import type { Price } from "@/Type/Price";
import { useState } from "react";

type Props = {
  clickQuantity: (valu: number) => void;
  classNames?: string;
};

export const Quantity = ({ clickQuantity, classNames }: Props) => {
  const [QCount, setQCount] = useState(1);

  const quantitys = (N_M: boolean) => {
    const rest = N_M ? QCount + 1 : QCount - 1;
    if (rest < 1) {
      setQCount(1);
      clickQuantity(1);
    } else {
      setQCount(rest);
      clickQuantity(rest);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setQCount(value);
      clickQuantity(value);
    } else if (e.target.value === "") {
      // Permitir borrar el input temporalmente
      setQCount(0);
    }
  };

  const handleBlur = () => {
    if (QCount < 1) {
      setQCount(1);
      clickQuantity(1);
    }
  };

  return (
    <div className={`form-group--number ${classNames}`}>
      <button className="up" onClick={() => quantitys(true)}>
        <i className="fa fa-plus"></i>
      </button>
      <button className="down" onClick={() => quantitys(false)}>
        <i className="fa fa-minus"></i>
      </button>
      <input
        className="form-control"
        type="text"
        value={QCount}
        placeholder="0"
        onChange={handleChange}
        onBlur={handleBlur}
        min={1}
        //readOnly // no te permite ser controlado por el usuario manualmente.
      />
    </div>
  );
};

export const QuantityCartv2 = ({
  clickQuantity,
  valuesData,
  idSku,
  isDisabled = false,
}: {
  clickQuantity: (valu: number, idSku?: string) => void;
  valuesData?: number;
  idSku?: string;
  isDisabled: boolean;
}) => {
  const [QCount, setQCount] = useState(valuesData ?? 1);

  const quantitys = (N_M: boolean) => {
    const rest = N_M ? QCount + 1 : QCount - 1;
    if (rest < 1) {
      setQCount(1);
      clickQuantity(1, idSku);
    } else {
      setQCount(rest);
      clickQuantity(rest, idSku);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value) && value > 0) {
      setQCount(value);
      clickQuantity(value, idSku);
    } else if (e.target.value === "") {
      // Permitir borrar el input temporalmente
      setQCount(0);
    }
  };

  const handleBlur = () => {
    if (QCount < 1) {
      setQCount(1);
      clickQuantity(1, idSku);
    }
  };

  return (
    <div className="form-group--number">
      <button
        className="up"
        onClick={() => quantitys(true)}
        disabled={isDisabled}>
        <i
          className={`fa fa-plus ${isDisabled ? "text-danger" : ""}`}
          style={{
            opacity: isDisabled ? 0.5 : 1,
            cursor: isDisabled ? "not-allowed" : "pointer",
          }}></i>
      </button>
      <button className="down" onClick={() => quantitys(false)}>
        <i className="fa fa-minus"></i>
      </button>
      <input
        className="form-control"
        type="text"
        value={QCount}
        placeholder="0"
        onChange={handleChange}
        onBlur={handleBlur}
        min={1}
      />
    </div>
  );
};
